/**
 * The last known profile (id, name, role: no credential), kept in IndexedDB so the field flow can open with no signal.
 * The session cookie stays the only credential; this is used only when the server cannot be reached and is removed on
 * sign-out or on a real 401.
 */
import { deleteDB, openDB } from 'idb'
import type { Me } from '../api/types'

const NAME = 'motores-session'
let db: ReturnType<typeof open> | null = null
const open = () => openDB(NAME, 1, { upgrade: (d) => { d.createObjectStore('profile') } })

export async function saveOfflineSession(me: Me): Promise<void> {
  db ??= open()
  await (await db).put('profile', {
    id: me.id,
    username: me.username,
    first_name: me.first_name,
    last_name: me.last_name,
    email: me.email,
    role: me.role,
    client_name: me.client_name,
  }, 'me')
}

export async function loadOfflineSession(): Promise<Me | null> {
  try {
    db ??= open()
    return ((await (await db).get('profile', 'me')) as Me | undefined) ?? null
  } catch {
    return null
  }
}

export async function clearOfflineSession(): Promise<void> {
  try {
    db ??= open()
    await (await db).delete('profile', 'me')
  } catch {
    /* nothing stored */
  }
}

export async function resetOfflineSession(): Promise<void> {
  if (db) (await db).close()
  db = null
  await deleteDB(NAME)
}
